import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/aiChatIcon.png'
import _imports_1 from '@/assets/img/loginExit.png'


const _withScopeId = n => (_pushScopeId("data-v-6843c8c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loginRight" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "content contentWidth" }
const _hoisted_4 = { style: {"position":"relative","margin-bottom":"24px"} }
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = { style: {"position":"absolute","top":"50%","right":"12px","transform":"translateY(-50%)"} }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "line" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["title"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "more" }, "MORE", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "more" }, "MORE", -1))
const _hoisted_17 = {
  key: 0,
  class: "user-bg"
}
const _hoisted_18 = {
  class: "user-edit",
  style: {"width":"100%","padding-top":"12px"}
}
const _hoisted_19 = { class: "user-opacity" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { style: {"flex":"1 0 calc(100% - 96px)"} }
const _hoisted_22 = ["title"]
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "employ" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px","font-weight":"bold","transform":"translateY(-1px)","display":"inline-block"} }, "→", -1))
const _hoisted_26 = { class: "systemIcon" }
const _hoisted_27 = { class: "iframePage contentWidth" }
const _hoisted_28 = { class: "line" }
const _hoisted_29 = {
  class: "contentHeight",
  style: {"position":"relative"}
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 1,
  class: "rich"
}
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 0,
  class: "btnBox",
  style: {"position":"absolute","bottom":"0px","width":"calc(100% - 48px)"}
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 2,
  style: {"height":"100%"}
}
const _hoisted_36 = {
  key: 0,
  style: {"height":"100%"}
}
const _hoisted_37 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_38 = {
  key: 2,
  style: {"height":"100%"}
}
const _hoisted_39 = {
  class: "contentWidth contentFooter",
  style: {"bottom":"0","left":"0"}
}
const _hoisted_40 = { class: "advertising" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 20px"} }, "|", -1))
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "rightPositionBox aiChatPosition" }
const _hoisted_44 = ["title"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "pointer"
}, null, -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  class: "rightPositionBox loginOutPosition"
}
const _hoisted_48 = ["title"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "pointer"
}, null, -1))
const _hoisted_50 = [
  _hoisted_49
]

import { ArrowRight } from '@element-plus/icons-vue';
import { ref, reactive, computed, nextTick, watch } from 'vue';
import { useStore } from 'vuex';
import {
  findAdvertB,
  findAdvertC,
  findSysSystemList,
  generateToken,
  getInformation,
  getSystemList
} from '../loginApi';
import type {
  AdvertATypeA,
  AdvertATypeB,
  AdvertATypeC,
  AdvertATypeD,
} from '../types';
// import { ElMessage, ElMessageBox,ElForm } from 'element-plus'
import Download from './Download.vue';
import BaseForm from './BaseForm.vue'
import UserManagement from './userManagement.vue';
import Permission from './Permission.vue';
import UserType from './userType.vue'
import aiChat from './aiChat.vue';
// import Products from './Products.vue'
import { useI18n } from 'vue-i18n';
import { logout } from '../loginApi';

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginRight',
  setup(__props, { expose: __expose }) {

const { t } = useI18n();
const store = useStore();
const windowhost = ref(process.env.VUE_APP_GLOB_IMG_URL);
const timestamp = new Date().getTime();
const isLogin = computed(() => (store.getters.getoken ? true : false));
const isSimulateToken = computed(() => (store.state.simulateToken ? 1 : 0));
const rsaToken = computed(() => (store.getters.getRsaToken));
const existMenu = computed(() => (store.getters.getExistMenu));
const firstTimeLogin = computed(() => (store.state.firstTimeLogin));
const getLanguageValue = computed(() => store.getters.getLanguageValue);
const userInfo = computed(() => store.getters.getUserInfo);
const isMore = ref(false);
const pageType = ref<any>('products');
const iframeUrl = ref('');
const pitchIndexA = ref(0);
const loading = ref(false);
const loadingB = ref(false);
const loadingC = ref(false);
// 富文本数据
const richData = ref('')
const data = reactive<{ lineTitleList: {name:string,callback?:any}[]; systemList: any[] }>({
  lineTitleList: [],
  systemList: [],
});

// 登出
const outLoading = ref(false)
const handleLogout = () => {
  if (outLoading.value) return
  outLoading.value = true
  logout().then(() => {
    outLoading.value = false
    store.dispatch('removerToken', '');
  }).catch(() => {
    outLoading.value = false
  });
};

function init() {
  watch(
    isLogin,
    (newData) => {
      if (!store.state.firstTimeLogin) {
        getData();
      }
      pageType.value = newData ? 'home' : 'products';
    },
    { immediate: true }
  );
  // 第一次登录
  watch(
    firstTimeLogin,
    (newData) => {
      if (!newData) {
        getData();
      }
    },
  );
  watch(
    pitchIndexA,
    (newData) => {
      if(newData == 0) setCarouseHeight()
    }
  );

  nextTick(() => {
    window.onresize = () => {
      return (() => {
        setCarouseHeight();
      })();
    };
  });
  // watch(userInfo, () => {
  //   const listA = advData.listA.map(e => e.id)
  //     // if (userInfo.value.userType !== 'normal' && !listA.includes('userManagement')) {
  //       advData.listA.push({
  //         id: 'userManagement',
  //         name: t('login.userManagement'),
  //         loginShow: true,
  //         permission: computed(()=>!(userInfo.value.userType !== 'normal' && !listA.includes('userManagement')))
  //       })
  //     // }
  //   // if (userInfo.value.isAdmin == 1 && !listA.includes('userType')) {
  //     advData.listA.push({
  //       id: 'userType',
  //       name: t('login.userType'),
  //       loginShow: true,
  //       permission: computed(()=>!(userInfo.value.userType == 'dev' && !listA.includes('userType')))
  //     })
  //   // }
  // },{ deep:true,immediate: true })
}
async function getData() {
  // pageType.value = "home"

  pitchIndexA.value = 0;
  if (isLogin.value) {
    pageType.value = 'home';
    getSysSystemList();
  } else {
    isMore.value = false;
    pitchIndexA.value = 0;
  }
  if (!advData.listB.length) {
    getAdvB();
  }
  if (!advData.listC.length) {
    getAdvC();
  }
  setCarouseHeight();
}

const aiChatOpen = ref(false)

let advData = reactive<{
  listA: any[];
  listB: AdvertATypeB[];
  listC: AdvertATypeC[];
  listD: AdvertATypeD[];
}>({
  listA: [
    { id: 'home', name: t('login.home') },
    { id: 'products', name: t('login.products') },
    { id: 'rich', name: t('login.findUs'), category:'contact_us' },
    { id: 'rich', name: t('login.companyProfile'), category:'company_profile' },
    { id: 'download', name: t('login.downLoad'), loginShow: true },
    {
      id: 'userManagement',
      name: t('login.userManagement'),
      loginShow: true,
      permission: computed(()=>!(userInfo.value.userType !== 'normal'))
    },
    {
      id: 'userType',
      name: t('login.userType'),
      loginShow: true,
      permission: computed(()=>!(userInfo.value.userType == 'dev' ))
    }

    // { id: 'userManagement', name: t('login.userManagement'),loginShow: true },
    // { id: 'userType', name: t('login.userType'),loginShow: true },
  ],
  listB: [],
  listC: [],
  listD: [
    // { id: 'rich', name: t('login.termsConditions'), category: '' },
    { id: 'rich', name: t('login.exceptions'), category: 'free_terms' },
    { id: 'rich', name: t('login.privacyPolicy'), category: 'privacy_policy' },
  ],
});
// 表头底部类型（用于区分A区D区的页面）
const categoryType = ref()
function handleAdvert(item: any, i: number) {
  pitchIndexA.value = i;
  categoryType.value = item.category;
  data.lineTitleList = [{name:item.name}];
  if (item.id === 'home') {
    pageType.value = isLogin.value ? 'home' : 'products';
    isMore.value = false;
  } else if (item.id === 'products') {
    pageType.value = 'products';
    isMore.value = true;
    if (!advData.listB.length) {
      getAdvB();
    }
    if (!advData.listC.length) {
      getAdvC();
    }
    setCarouseHeight();
  } else if (item.id === 'rich') {
    pageType.value = 'rich';
    setLine('replace', [{ name: item.name }])
    getInformation(item.category).then(res => {
      try {
        richData.value = res.data[0].content
        setImgToLink()
      } catch (err) {
        richData.value = ''
      }
    })
  } else {
    if (!advData.listA[i].loginShow) {
      pageType.value = 'iframe';
      iframeUrl.value = item.redirectUrl;
    } else {
      pageType.value = item.id;
    }
  }
}
// 广告区B
function getAdvB() {
  loadingB.value = true;
  findAdvertB().then((res) => {
    advData.listB = res.data;
    loadingB.value = false;
  });
}
// 广告区C
const listCIndex = ref(0);
const carouselRefC = ref<any>(null);
function getAdvC() {
  loadingC.value = true;
  findAdvertC().then((res) => {
    // advData.listC = setAxLanguage(res.data, ['content', 'title']);
    advData.listC = res.data
    loadingC.value = false;
  });
}
function switchover(type: string) {
  if (type === 'next') {
    if ((listCIndex.value + 1) * 3 < advData.listC.length) {
      listCIndex.value += 1;
    } else {
      listCIndex.value = 0;
    }
  } else {
    if (listCIndex.value > 0) {
      listCIndex.value -= 1;
    } else {
      listCIndex.value = Math.ceil(advData.listC.length / 3) - 1;
    }
  }
  carouselRefC.value.setActiveItem(listCIndex.value);
}
function handleAdvC(item: any) {
  // data.lineTitleList = [{ name: t('login.products') }, { name: item.title }];
  setLine('replace',[{ name: t('login.products') }, { name: item.name }])
  pageType.value = 'richC';
  pitchIndexA.value = 1
  richData.value = item.content
  // 图片现在跳转链接
  setImgToLink()
}
// 图片有链接跳转
function setImgToLink() {
  setTimeout(() => {
    document.querySelectorAll('#richBox img').forEach((element: any) => {
      const link:any = element.getAttribute('data-href')
      if (link) {
        element.style.cursor = "pointer";
        element.addEventListener('click', function() {
          // 在这里编写点击事件的处理逻辑
          window.open(link, '_blank');
        });
      }
    })
  }, 0);
}
function setLine(type: 'replace' | 'add', arr: any[]) {
  if (type == 'replace') {
    data.lineTitleList = arr
  } else {
    data.lineTitleList = data.lineTitleList.concat(arr)
  }
}
function delLine(i:number) {
  data.lineTitleList = data.lineTitleList.slice(0,i)
}

// 获取当前用户系统
function getSysSystemList() {
  loading.value = true;
  findSysSystemList().then((res) => {
    data.systemList = res.data;
  }).finally(() => loading.value = false)
  getSystemList().then((res) => {
    store.dispatch('setSystem',res.data)
  })
}
function toSystem(item: {accessUrl: string,code: string}) {
  generateToken(item.code).then(res => {
    const token = encodeURIComponent(res.data)
    let path = `${item.accessUrl}?token=${token}`
    if (isSimulateToken.value) {
      path = `${item.accessUrl}?token=${token}&simulateLogin=${isSimulateToken.value}`
    }
    // window.location.href = path
    window.open(path,'_blank');
  })
}

// b区轮播图
const indicatorIndexB = ref(0);
const carouselRef = ref<any>(null);
function handleIndicator(i: number) {
  indicatorIndexB.value = i;
  carouselRef.value.setActiveItem(i);
}
function changeIndicator(i: number) {
  indicatorIndexB.value = i;
}
function handleCarousel(url: string) {
  if (url) window.open(url);
}

const contentRef = ref<any>(null);
const carouseHeight = ref(0);
const iframeRef = ref<any>(null);
function setCarouseHeight() {
  setTimeout(() => {
    try{
      carouseHeight.value = contentRef.value.clientWidth / 1.96491;
    }catch(err){}
  }, 10);
}
function handleBread(i: number) {
  if (data.lineTitleList.length > 1) {
    if (data.lineTitleList[i + 1].callback) {
      data.lineTitleList[i + 1].callback()
      delLine(i+1)
    }else if (i == 0) {
      pageType.value = 'products';
      pitchIndexA.value = isMore.value ? 1 : 0
    }
  }
}
init();

__expose({
  getSysSystemList,
  getData,
});

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "contentWidth contentHeader",
      style: {"top":"0","left":"0"},
      ref_key: "contentRef",
      ref: contentRef
    }, [
      _createElementVNode("div", {
        class: "u advertising",
        style: _normalizeStyle([{ minHeight: isLogin.value ? '0px' : '21px' }, {"position":"relative","z-index":"2"}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advData).listA, (item, i) => {
          return _withDirectives((_openBlock(), _createElementBlock("span", {
            key: item.id,
            class: _normalizeClass(pitchIndexA.value == i ? 'isPitch' : ''),
            onClick: ($event: any) => (handleAdvert(item, i)),
            style: _normalizeStyle({ marginLeft: getLanguageValue.value==='en'?'28px':'40px' })
          }, _toDisplayString(item.name), 15, _hoisted_2)), [
            [_vShow, (!item.loginShow || (item.loginShow && isLogin.value)) && !item.permission]
          ])
        }), 128))
      ], 4)
    ], 512),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(_component_el_carousel, {
          trigger: "click",
          onChange: changeIndicator,
          interval: 5000,
          arrow: "never",
          "indicator-position": "none",
          ref_key: "carouselRef",
          ref: carouselRef,
          "initial-index": indicatorIndexB.value,
          height: carouseHeight.value + 'px'
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advData).listB, (item) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: item.ossUrl,
                    style: _normalizeStyle([{"width":"100%","cursor":"pointer"}, 'height:' + carouseHeight.value + 'px']),
                    alt: "",
                    ref_for: true,
                    ref: "imgggg",
                    onClick: ($event: any) => (handleCarousel(item.accessUrl))
                  }, null, 12, _hoisted_5)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["initial-index", "height"]),
        _createElementVNode("div", null, [
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advData).listB, (item, i) => {
              return (_openBlock(), _createElementBlock("li", {
                style: {"padding":"4px 0"},
                key: item.id
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(indicatorIndexB.value == i ? 'indicatorSel' : 'indicator'),
                  onClick: ($event: any) => (handleIndicator(i))
                }, null, 10, _hoisted_7)
              ]))
            }), 128))
          ])
        ])
      ])), [
        [_vShow, !isMore.value],
        [_directive_loading, loadingB.value]
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_breadcrumb, {
          "separator-icon": _unref(ArrowRight),
          style: {"line-height":"48px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { style: {"color":"#fefefc"} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login.products')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["separator-icon"]),
        _withDirectives(_createElementVNode("span", {
          style: {"cursor":"pointer","font-size":"14px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
            isMore.value = true;
            pitchIndexA.value = 1;
          })
        }, "MORE", 512), [
          [_vShow, !isMore.value]
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "product",
        style: _normalizeStyle(isMore.value ? 'height:calc(100vh - 209px)' : '370px')
      }, [
        (pitchIndexA.value == 0 && !isMore.value)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_carousel, {
              key: 0,
              height: "360px",
              interval: 0,
              ref_key: "carouselRefC",
              ref: carouselRefC,
              arrow: "never",
              "initial-index": listCIndex.value
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(_unref(advData).listC.length / 3), (i) => {
                  return (_openBlock(), _createBlock(_component_el_carousel_item, { key: i }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 16 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advData).listC.slice(
                  (i - 1) * 3,
                  (i - 1) * 3 + 3
                ), (item) => {
                            return (_openBlock(), _createBlock(_component_el_col, {
                              span: 8,
                              key: item.id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "productBox",
                                  style: _normalizeStyle(isMore.value ? 'margin-bottom: 24px' : ''),
                                  onClick: ($event: any) => (handleAdvC(item))
                                }, [
                                  _createElementVNode("img", {
                                    src: item.ossUrl,
                                    alt: "",
                                    style: _normalizeStyle([{"width":"100%","height":"170px"}, 'height:' + carouseHeight.value * 0.3859649 + 'px'])
                                  }, null, 12, _hoisted_10),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("h4", null, _toDisplayString(item.name), 1),
                                    _createElementVNode("div", {
                                      class: "textOverFlow",
                                      title: item.introduction
                                    }, _toDisplayString(item.introduction), 9, _hoisted_11),
                                    _hoisted_12
                                  ])
                                ], 12, _hoisted_9)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["initial-index"])), [
              [_vShow, !isMore.value]
            ])
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_el_row, { gutter: 16 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advData).listC, (item) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                span: 8,
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "productBox",
                    style: _normalizeStyle(isMore.value ? 'margin-bottom: 24px' : ''),
                    onClick: ($event: any) => (handleAdvC(item))
                  }, [
                    _createElementVNode("img", {
                      src: item.ossUrl,
                      alt: "",
                      style: _normalizeStyle([{"width":"100%","height":"170px"}, 'height:' + carouseHeight.value * 0.3859649 + 'px'])
                    }, null, 12, _hoisted_14),
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", null, _toDisplayString(item.name), 1),
                      _createElementVNode("div", {
                        class: "textOverFlow",
                        title: item.introduction
                      }, _toDisplayString(item.introduction), 9, _hoisted_15),
                      _hoisted_16
                    ])
                  ], 12, _hoisted_13)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 512), [
          [_vShow, isMore.value]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("span", {
            class: "arrows arrowsLeft",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (switchover('up')))
          }, [
            _createVNode(_component_el_icon, { size: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowLeft)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("span", {
            class: "arrows arrowsRight",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (switchover('next')))
          }, [
            _createVNode(_component_el_icon, { size: 20 }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowRight))
              ]),
              _: 1
            })
          ])
        ], 512), [
          [_vShow, !isMore.value]
        ])
      ], 4)), [
        [_directive_loading, loadingC.value]
      ])
    ], 512), [
      [_vShow, pageType.value == 'products']
    ]),
    (isLogin.value && pageType.value == 'home')
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.systemList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "systemBox",
                  key: item.id,
                  onClick: ($event: any) => (toSystem(item))
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", {
                      title: item.name
                    }, [
                      _createElementVNode("strong", null, [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ])
                    ], 8, _hoisted_22),
                    _createElementVNode("div", {
                      class: "systemCon",
                      title: item.describe
                    }, _toDisplayString(item.describe), 9, _hoisted_23),
                    _createElementVNode("div", _hoisted_24, [
                      _createTextVNode(_toDisplayString(_unref(t)('login.clickInto')) + " ", 1),
                      _hoisted_25
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_el_avatar, {
                      shape: "square",
                      size: 96,
                      src: item.logoUrl,
                      style: {"background-color":"white"}
                    }, null, 8, ["src"])
                  ])
                ], 8, _hoisted_20))
              }), 128))
            ])), [
              [_directive_loading, loading.value]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_el_breadcrumb, {
          "separator-icon": _unref(ArrowRight),
          separator: "/",
          style: {"line-height":"48px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.lineTitleList, (item, i) => {
              return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
                style: {"color":"#fefefc"},
                key: i,
                to: "/",
                onClick: ($event: any) => (handleBread(i))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["separator-icon"])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", {
          class: "contentBox",
          style: _normalizeStyle({ height: pageType.value == 'richC' ? 'calc(100% - 72px)' : '100%' })
        }, [
          (pageType.value == 'iframe')
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                class: "iframe",
                id: "iframe",
                src: iframeUrl.value,
                scrolling: "auto",
                frameborder: "0",
                style: {"width":"100%","height":"100%"},
                ref_key: "iframeRef",
                ref: iframeRef
              }, null, 8, _hoisted_30))
            : _createCommentVNode("", true),
          (pageType.value == 'rich' || pageType.value == 'richC')
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", {
                  innerHTML: richData.value,
                  id: "richBox"
                }, null, 8, _hoisted_32),
                (pageType.value == 'richC')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", {
                        class: "btn pointer",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleBread(0)))
                      }, _toDisplayString(_ctx.$t('login.getBack')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (categoryType.value === 'contact_us')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createVNode(BaseForm, { onHandleRoute: handleAdvert })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (isLogin.value && pageType.value != "iframe" && pageType.value != "rich" && pageType.value !== "richC")
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _withDirectives(_createVNode(Download, {
                  systemList: data.systemList
                }, null, 8, ["systemList"]), [
                  [_vShow, pageType.value == 'download']
                ]),
                (pageType.value === 'userManagement')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(UserManagement, {
                        onSetLine: setLine,
                        onDelLine: delLine
                      })
                    ]))
                  : _createCommentVNode("", true),
                (pageType.value === 'userType')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createVNode(UserType, {
                        onSetLine: setLine,
                        onDelLine: delLine
                      })
                    ]))
                  : _createCommentVNode("", true),
                (pageType.value === 'permission')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createVNode(Permission, {
                        onSetLine: setLine,
                        onDelLine: delLine,
                        systemList: data.systemList
                      }, null, 8, ["systemList"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 4)
      ])
    ], 512), [
      [_vShow, pageType.value !== 'home' && pageType.value !== 'products']
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("footer", _hoisted_40, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('login.publicity')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advData).listD, (item) => {
          return (_openBlock(), _createElementBlock("span", {
            style: {"color":"#b1b1b1"},
            key: item.id
          }, [
            _hoisted_41,
            _createElementVNode("span", {
              class: "footerSpan",
              onClick: ($event: any) => (handleAdvert(item, pitchIndexA.value))
            }, _toDisplayString(item.name), 9, _hoisted_42)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", {
        class: "rightPositionBox-Content",
        title: _ctx.$t('aiChat.title'),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (aiChatOpen.value = true))
      }, _hoisted_46, 8, _hoisted_44)
    ]),
    _createVNode(aiChat, {
      visible: aiChatOpen.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((aiChatOpen).value = $event))
    }, null, 8, ["visible"]),
    (isLogin.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createElementVNode("div", {
            class: "rightPositionBox-Content",
            title: _ctx.$t('login.logout1'),
            onClick: handleLogout
          }, _hoisted_50, 8, _hoisted_48)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})